import config from '@/config';
import { requests } from '.';
const USER_SERVICE_URL = config === null || config === void 0 ? void 0 : config.USER_SERVICE_URL;
export const UserService = {
    getAll: (locationId) => requests(USER_SERVICE_URL).get(`/`, {
        params: {
            locationId,
        },
    }),
    getUserDetails: (id) => requests(USER_SERVICE_URL).get(`/${id}`),
};
